export default function (Vue) {
  Vue.auth = {
    setUser (user, pass, ppjk, npwp) {
      localStorage.setItem('user', user)
      localStorage.setItem('pass', pass)
      localStorage.setItem('ppjk', ppjk)
      localStorage.setItem('npwp', npwp)
    },

    getUser () {
      var user = localStorage.getItem('user')
      var pass = localStorage.getItem('pass')
      var ppjk = localStorage.getItem('ppjk')
      var npwp = localStorage.getItem('npwp')

      if (!user || !pass || !ppjk || !npwp) {
        return null
      } else {
        return user
      }
    },

    getPass () {
      var user = localStorage.getItem('user')
      var pass = localStorage.getItem('pass')
      var ppjk = localStorage.getItem('ppjk')
      var npwp = localStorage.getItem('npwp')

      if (!user || !pass || !ppjk || !npwp) {
        return null
      } else {
        return pass
      }
    },

    getPpjk () {
      var user = localStorage.getItem('user')
      var pass = localStorage.getItem('pass')
      var ppjk = localStorage.getItem('ppjk')
      var npwp = localStorage.getItem('npwp')

      if (!user || !pass || !ppjk || !npwp) {
        return null
      } else {
        return ppjk
      }
    },

    destroyUser () {
      localStorage.removeItem('user')
      localStorage.removeItem('pass')
      localStorage.removeItem('ppjk')
      localStorage.removeItem('npwp')
    },
    isLoged () {
      if (this.getUser()) {
        return true
      } else {
        return false
      }
    }
  }

  Object.defineProperties(Vue.prototype, {
    $auth: {
      get: () => {
        return Vue.auth
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/auth.js